import MediaSources from "../../media_sources";
import { parseUrlParams } from '../../../core/library/url';
import store from "../../../core/library/store";
import {LanguageStorageKey} from "../../index";

const isLocal = window.location.hostname.indexOf('localhost') + 1 > 0;

const RBTHCdnMedia = 'https://mf.b37mrtl.ru/rbthmedia';
const GWCdnMedia = 'https://cdn.gw2ru.com';

const IsRuVersion = window.location.host.indexOf('ru-backend.gw2ru.com') + 1 > 0;

export const gateway = {
    SHOW_LANGS: true,
    BASE_DOMAIN: isLocal ? 'https://backend.gw2ru.com' : 'https://' + window.location.hostname,
    APP_CLASS: 'vm',
    PROJECT_NAME: 'vm',
    PROJECT_PREFIX: 'vm',
    LOCALE: IsRuVersion ? "ru" : "en",
    PREVIEW_DOMAIN: isLocal ? "http://localhost:14002" : "https://ru.gw2ru.com",
    PREVIEW_HASH: "AE30845FBF6EE09305710B753A9C264C",
    SOCKET: 'http://localhost:9001',

    PROJECT: {
        // project name
        NAME: 'vm',
        // project default layout
        LAYOUT: "default",
        // project api path
        API: isLocal ? `http://localhost:14001/api/backend` : `/api/backend`,
        ELASTIC_API: isLocal ? `http://localhost:14001/api/backend/elastic`: `/api/backend/elastic`,
    },


    OAUTH: {
        // url for oauth domain
        URL: `https://auth.b37m.ru/`,
        // current project domain
        PROJECT_DOMAIN: isLocal ? `localhost:3000` : window.loc,
        // current project url path
        PROJECT_PATH: isLocal ? `http://localhost:3000` : `https://` + window.location.hostname,
        // path for oauth api
        API: `https://auth.b37m.ru/auth`,
        // path for oauth users
        OAUTH_USER_PATH: `https://auth.b37m.ru/users/`,
        // prefix for authorization tokens
        PREFIX: 'oauth_',
    },

    ELASTIC: {
        API: isLocal ? `http://localhost:14001/api/backend/elastic` : "/api/backend/elastic",
    },


    LANGS: [
        {title: "English", domain: "http://localhost:3000"},
        {title: "Russian", domain: "http://ru.localhost:3000"}
    ],

    UPLOAD: {
        "path": isLocal ? "http://localhost:14001/api/backend/media" : "/api/backend/media"
    },
    VIEWS: {
        documents: {
            "article": "default_view_vm",
            "authors": "authors_view",
            "person": "authors_view",
            "pa_theater": "authors_view",
            "hubauthors": "authors_view",
            "category": "category_view",
            "categories": "category_view",
            "useful_categories": "category_view",
            "hubcats": "HubCategoryView",
            "country": "country_view",
            "tag": "tag_view",
            "tags": "category_view",
            "genre": "category_view",
            "copyright": "category_view",
            "media_selection": "category_view",
            "courses": "CourseView",
            "manufacture": "category_view",
            "award": "category_view",
            "trends": "category_view",
            "contacts_tags": "tag_view",
            "trend": "trend_view",
            "page": "page_view",
            "show": "show_view",
            "news": "NewsController",
            "languages": "languages_view",
            "newspaper": "newspaper_view",
            "rnewspaper": "rnewspaper_view",
            "schedule": "schedule_view",
            "arates": 'arates_view',
            "aviews": 'aviews_view',
            "mcat": 'anons_view',
            "polls": 'poll',
            "covid": "covid",
            "stop": "stopwords",
            "contacts": "contacts_index",
            "contacts_type": "contacts_types",
            "redirects": "RedirectsViews",
            "units": "UnitsView",
        },
        documents_add: {
            "units": "AddUnit",
            "lessons": "AddLessons",
            "book": "AddBook",
            "performing_arts": "AddPerformingArts",
            "music": "add_music",
            "courses": "AddCourses",
            "tests": "AddTests",
            "article": "add_article_vm",
            "trend": "add_trend",
            "news": "add_news",
            "author": "add_author",
            "person": "add_person",
            "pa_theater": "add_pa_theater",
            "hubauthors": "HubAddAuthor",
            "authors": "add_author",
            "category": "add_category",
            "hubcats": "HubAddCategory",
            "country": "AddCountry",
            "tags": "add_category",
            "copyright": "add_category",
            "genre": "add_category",
            "media_selection": "add_category",
            "trends": "add_category",
            "tag": "add_tag",
            "manufacture": "add_category",
            "mcat": "anons_add",
            "film": "add_films",
            "arteldoc": "add_films",
            "banner": "add_banner",
            "page": "add_page",
            "newspaper": "add_newspaper",
            "rnewspaper": "add_rnewspaper",
            "battle": "add_battle",
            "schedule": "add_schedule",
            "arates": "arate_add",
            "aviews": "aviews_add",
            "infographic": "infographics_add",
            "polls": "poll_add",
            "covid": "covid",
            "afisha": "afisha_vm",
            "regionmat": "region_material",
            "mgallery": "mgallery",
            "stories": "add_news",
            "trips": "StoriesCards",
            "receipt": "receipt",
            "stt": "stt",
            "stop": "add_stopwords",
            "contacts": "add_contacts",
            "redirects": "RedirectsAdd",
            "languages": "AddLanguage",
            "serials": "AddSerials",
            "episodes": "AddEpisode",
            "award": "AddAward",
            "hselections": "AddHSelection",
            "categories": "GWArticlesCategory",
            "useful_categories": "GWArticlesCategory",
        }
    },
    MENU: [
        {
            'title': 'DASHBOARD',
            'path': '/',
            'component': 'dashboard_index',
            'icon': 'dashboard',

        },

        {
            'title': 'RUSSIAN_CONTENT',
            'path': '/documents/:type',
            'component': 'default_document',
            'subroutes': [
                {
                    'path': '/documents/:type/:id',
                    'component': 'add_documents',
                },
                {
                    'path': '/documents/:type/:id/preview',
                    'component': 'preview',
                },
                {
                    'path': '/documents/:type/create',
                    'component': 'add_documents',
                },
                {
                    'path': '/documents/episode/:id/chat',
                    'component': 'episode_chat',
                },
                {
                    'path': '/archive',
                    'component': 'archive',
                },
            ],
            'icon': 'container',
            'submenu': [
                {
                    'title': 'FILMS',
                    'path': '/documents/film',
                    'icon': 'video-camera',
                },
                {
                    'title': 'BOOKS',
                    'path': '/documents/book',
                    'icon': 'book',
                },
                {
                    'title': 'PERFORMING_ARTS',
                    'path': '/documents/performing_arts',
                    'icon': 'customer-service',
                },
                {
                    'title': 'MUSIC',
                    'path': '/documents/music',
                    'icon': 'sound',
                },
                {
                    'title': 'MEDIA_SELECTION',
                    'path': '/documents/media_selection',
                    'icon': 'database',
                },
                {
                    'title': 'PERSONS',
                    'path': '/documents/person',
                    'icon': 'database',
                },
                {
                    'title': 'THEATERS',
                    'path': '/documents/pa_theater',
                    'icon': 'database',
                },
                {
                    'title': 'GENRES',
                    'path': '/documents/genre',
                    'icon': 'database',
                },
                {
                    'title': 'COPYRIGHT',
                    'path': '/documents/copyright',
                    'icon': 'database',
                },
                // {
                //     'title': 'CONTENT_PERFORMANCES',
                //     'path': '/documents/online_performances',
                //     'icon': 'database',
                // },
                // {
                //     'title': 'MUSEUM',
                //     'path': '/documents/museum',
                //     'icon': 'database',
                // },
            ]
        },

        {
            "title": "RUSSIAN_LANGUAGE",
            'icon': 'container',
            'submenu': [
                {
                    'title': 'COURSES',
                    'path': '/documents/courses',
                    'icon': 'file-text',
                },
                {
                    'title': 'UNITS',
                    'path': '/documents/units',
                    'icon': 'file-text',
                },
                {
                    'title': 'LESSONS',
                    'path': '/documents/lessons',
                    'icon': 'file-text',
                },
                {
                    'title': 'TESTS',
                    'path': '/documents/tests',
                    'icon': 'file-text',
                },
                {
                    'title': 'LEARN_TEXT',
                    'path': '/documents/russian_ltext',
                    'icon': 'container',
                },
                {
                    'title': 'LEARN_MEMS',
                    'path': '/documents/russian_lmems',
                    'icon': 'smile',
                },
                {
                    'title': 'LEARN_VIDEOS',
                    'path': '/documents/russian_lvideos',
                    'icon': 'video-camera',
                },
            ]
        },

        {
            "title": "LEARN_RUSSIA",
            'icon': 'container',
            'submenu': [
                {
                    'title': 'ARTICLES',
                    'path': '/documents/articles',
                    'icon': 'file-text',
                },
                {
                    'title': 'CATEGORIES',
                    'path': '/documents/categories',
                    'icon': 'database',
                },
            ]
        },

        {
            "title": "USEFUL_INFORMATION",
            'icon': 'container',
            'submenu': [
                {
                    'title': 'ARTICLES',
                    'path': '/documents/useful_articles',
                    'icon': 'file-text',
                },
                {
                    'title': 'TRIPS',
                    'path': '/documents/trips',
                    'icon': 'database',
                },
                {
                    'title': 'CATEGORIES',
                    'path': '/documents/useful_categories',
                    'icon': 'database',
                },
            ]
        },

        {
            "title": "DATABASE",
            "icon": "database",
            "submenu": [
                {
                    "title": "LANGUAGES",
                    "path": "/documents/languages",
                    "icon": "global",
                },
                {
                    'title': "CATEGORIES",
                    "path": "/documents/category",
                    "icon": "file-text"
                },
                {
                    'title': "TAGS",
                    "path": "/documents/tags",
                    "icon": "file-text"
                },
                {
                    'title': "TRENDS",
                    "path": "/documents/trends",
                    "icon": "file-text"
                },
                {
                    'title': "AUTHORS",
                    "path": "/documents/authors",
                    "icon": "user"
                },
            ]
        },

        {
            title: "INSTRUMENTS",
            icon: "code",
            'submenu': [
                {
                    title: "COLLAGE_MAKER",
                    path: "/collage_maker",
                    icon: "picture",
                    component: 'CollageMaker',
                },
                {
                    'title': 'REDIRECTS',
                    'path': '/documents/redirects',
                    'icon': 'experiment',
                },
                {
                    title: 'MEDIA_GALLERY_LIST',
                    path: '/mediagallery',
                    icon: 'picture',
                    component: 'media_gallery',
                },
                {
                    title: 'CONVERTER',
                    path: '/converter',
                    icon: 'video-camera',
                    component: 'ConverterIndex',
                },
                {
                    title: 'SERVICE_MAIL_LOGS',
                    path: '/service-mail/logs',
                    icon: 'file-text',
                    component: 'ServiceMailLogs',
                }
            ]
        },
        {
            title: "EMAIL_SENDER",
            "icon": "mail",
            'subroutes': [
                {
                    'path': '/mail/subscribers',
                    'component': 'NewsletterSubscribers',
                },
                {
                    'path': '/mail/:type',
                    'component': 'SenderIndex',
                },
                {
                    'path': '/mail/:type/settings',
                    'component': 'NewsletterSettings',
                },
                {
                    'path': '/mail/:type/:id/view',
                    'component': 'NewsletterPreview',
                },
                {
                    'path': '/mail/:type/:id',
                    'component': 'NewsletterIndex',
                },
            ],
            submenu: [
                {
                    title: 'DAILY',
                    path: '/mail/daily',
                    icon: "mail",
                },
                {
                    title: 'WEEKLY',
                    path: '/mail/weekly',
                    icon: "mail",
                },
                {
                    title: 'SUBSCRIBERS',
                    path: '/mail/subscribers',
                    icon: "team",
                    component: 'NewsletterSubscribers',
                }
            ],
        },
        {
            'title': 'PUSH',
            'path': '/push',
            'icon': 'notification',
            'component': 'push',
        },
        {
            'title': 'BANNERS',
            'path': '/documents/banner',
            'icon': 'database',
        },
        {
            'title': 'WIDGETS',
            'path': '/widgets',
            'icon': 'appstore',
            'component': 'widget',
            'submenu': [
                {
                    'title': 'WTYPE_ALL',
                    'path': '/widgets',
                    'icon': 'appstore',
                    'component': 'widget',
                },
                {
                    'title': 'WTYPE_MAIN_PAGE',
                    'path': '/widgets/type/main',
                    'icon': 'appstore',
                },
                {
                    'title': 'WTYPE_LEARN_RUSSIAN',
                    'path': '/widgets/type/learn_russia',
                    'icon': 'appstore',
                },
                {
                    'title': 'WIDGET_TYPE_RUSSIAN_LANGUAGE',
                    'path': '/widgets/type/russian_language',
                    'icon': 'appstore',
                },
                {
                    'title': 'WIDGET_TYPE_RUSSIAN_CONTENT',
                    'path': '/widgets/type/russian_content',
                    'icon': 'appstore',
                },
                {
                    'title': 'WIDGET_TYPE_USEFUL_INFO',
                    'path': '/widgets/type/useful_info',
                    'icon': 'appstore',
                },
                {
                    'title': 'WTYPE_TYPE_MENU',
                    'path': '/widgets/type/menu',
                    'icon': 'appstore',
                },
                {
                    'title': 'WTYPE_TYPE_EMAIL',
                    'path': '/widgets/type/email',
                    'icon': 'appstore',
                },
                {
                    'title': 'WTYPE_TYPE_MOBILE',
                    'path': '/widgets/type/mobile_menu',
                    'icon': 'appstore',
                },
                {
                    'title': 'WTYPE_TYPE_BOOKS',
                    'path': '/widgets/type/books',
                    'icon': 'appstore',
                },
                {
                    'title': 'WTYPE_TYPE_FILMS',
                    'path': '/widgets/type/films',
                    'icon': 'appstore',
                },
                {
                    'title': 'WTYPE_TYPE_PERFORMING_ARTS',
                    'path': '/widgets/type/performing_arts',
                    'icon': 'appstore',
                },
                {
                    'title': 'WTYPE_TYPE_MUSIC',
                    'path': '/widgets/type/music',
                    'icon': 'appstore',
                },
                // {
                //     'title': 'WTYPE_HELP_INFORMATION',
                //     'path': '/widgets/type/help_information',
                //     'icon': 'appstore',
                // },
            ],
            'subroutes': [
                {
                    'path': '/widgets/:id',
                    'component': 'widget_edit',
                },
                {
                    'path': '/widgets/type/:type',
                    'component': 'widget',
                },

            ]
        },
        {
            'title': 'PAGES',
            'path': '/documents/page',
            'icon': 'file-text',
        },
        {
            'title': 'COMMENTS',
            'path': '/comments',
            'icon': 'message',
            'component': 'QAComments',
        },
        {
            'title': 'USERS',
            'path': '/users',
            'icon': 'user',
            'subroutes': [
                {
                    'path': '/users/:id',
                    'component': 'users_edit',
                },
                {
                    'path': '/users/groups/add',
                    'component': 'add_group',
                },
                {
                    'path': '/users/groups/:id',
                    'component': 'add_group',
                }
            ],
            'submenu': [
                {
                    'title': 'USERS',
                    'path': '/users',
                    'icon': 'user',
                    'component': 'users_index',
                },
                {
                    'title': 'GROUPS',
                    'icon': 'idcard',
                    'path': '/users/groups',
                    'component': 'groups_index',
                },
                {
                    'title': 'PERMISSIONS',
                    'icon': 'idcard',
                    'path': '/users/permissions',
                    'component': 'permission_index',
                }
            ]
        },
        {
            'title': 'REPORTS',
            'icon': 'database',
            'submenu': [
                {
                    'title': 'DIGITAL',
                    'path': '/reports/digital',
                    'icon': 'database',
                    'component': 'ReportDigital',
                },
                {
                    'title': 'REGISTRATIONS',
                    'path': '/reports/registrations',
                    'icon': 'team',
                    'component': 'RegistrationsReport',
                },
                {
                    'title': 'INSTAGRAM_FACEBOOK',
                    'path': '/reports/meta-sources',
                    'icon': 'link',
                    'component': 'MetaSourcesReport',
                },
            ]
        }
    ],


    WORKFLOW: {
        SHOW_LINK: true,
        SHOW_SEARCH: true,
        STATUSES: ['READY', 'ARCHIVE', 'PUBLISH'],
        STATUSES_COLOR: {
            'DRAFT': 'gray',
            'READY': 'volcano',
            'ARCHIVE': 'purple',
            'PUBLISH': 'green',
        },
        DEFAULT: 'ARCHIVE',
        LOCK_FOR: [
            'films',
            'serials',
            'infographic',
            "episodes",
            'episode',
            'article',
            'news',
            'gallery',
            'meaning'
        ],
        WORKFLOW_FOR: [
            'films',
            'serials',
            'episode',
            "episodes",
            'article',
            'gallery',
            'meaning'
        ],
    },
    WIDGETS: {
        WTYPE: ['main', 'learn_russia', 'russian_language', 'russian_content', 'useful_info', 'menu', 'email', 'mobile_menu', 'books', 'films', 'performing_arts', 'music'],
        VIEWS: [
            {name: 'Big slider', key: 'big_slider'},
            {name: 'Slider', key: 'slider'},
            {name: '2 big material + 4 small', key: 'big2_small4'},
            {name: '2 big material + 3 small', key: 'big2_small3'},
            {name: '1 big material + 3 small', key: 'big1_small3'},
            {name: '1 big material + 2 middle', key: 'big1_middle2'},
            {name: '2 big materials', key: 'big2'},
            {name: '1 big + 2 with summary', key: 'big1_small2_summary'},
            {name: 'menu_dropdown', key: 'menu_dropdown'},
            {name: 'menu', key: 'menu_simple'},


            {name: '[catalog] 2 big items', key: 'c2big'},
            {name: '[catalog] slider', key: 'c_slider'},
            {name: '[catalog] big slider', key: 'catalog_big_slider'},
            {name: '[catalog] films last listing', key: 'films_last'},
            {name: '[catalog] performing arts main slider', key: 'pa_main_slider'},
            {name: '[catalog] performing arts selection', key: 'pa_selection'},
            {name: '[catalog] music main slider', key: 'music_main_slider'},
            {name: '[catalog] music selection', key: 'music_selection'},
            {name: '[catalog] selection listing', key: 'selection'},
            {name: '[catalog] selection listing book', key: 'book_selection'},
            {name: '[catalog] genres', key: 'genres'},

            {name: '[banners] full-width banner', key: 'banner_widget'},
            {name: '[banners] max-width banner', key: 'banner_widget_limited'},
            {name: '[subscribe] max-width banner', key: 'subscribe'},

            {name: 'Email one big material', key: 'email_one_big'},
            {name: 'Email two row materials', key: 'email_two_row'},
            {name: 'Email 1 column ', key: 'email_one_column'},



            // {name: 'Слайдер с маленькими картинками', key: 'slider_min_images'},
            // {name: 'Слайдер со средними картинками', key: 'slider_middle_images'},
            // {name: 'Слайдер с большими картинками', key: 'slider_big_images'},
            // {name: 'Подборки', key: 'selections'},
            // {name: 'Фильм', key: 'film'},
            // {name: 'Выборки', key: 'preset'},
            // hub
        ],
        TYPES: ['Languages', 'Category', 'Tags', 'Trends', 'Authors', 'Articles', 'Categories', 'Banner', 'Russian_courses', 'Useful_categories', 'Online_performances', 'Museum', 'Tests', 'Russian_ltext', 'Russian_lmems', 'Russian_lvideos', 'Useful_articles', 'Trips', 'Film', 'Book', 'Performing_Arts', 'Music', 'Media_selection', 'Person', 'Pa_theater', 'Genre'],
    },

    MEDIA: {
        // path for cdn content
        CDN: {
            IMAGES: isLocal ? "http://localhost:14001/images" : "/arch/images",
            IMAGE: isLocal ? "http://localhost:14001/images" : "/arch/images",
            M3U8: isLocal ? "http://localhost:14001/m3u8" : "/arch/m3u8",
            VIDEO: isLocal ? "http://localhost:14001/videos" : "/arch/videos",
            PDF: isLocal ? "" : "/arch/pdf",
            AUDIO: "/arch/stt",
            VTT: "/arch/vtt",
        },
        // available copyright sources
        SOURCES: MediaSources,
        // available upload types
        UPLOAD_AVAILABLE: ['jpg', 'gif', 'png', 'jpeg', 'mp4', 'mp3'],
        // available embedded sources
        EMBEDDED_SOURCES: ['youtube.com', 'facebook.com', 'youtu.be', `tvzvezda.ru`],
        EMEDDED_PREPARE: {
            'youtu.be': (path) => {
                let params = path.split('/');
                return (
                    `<iframe width="560" height="315" src="https://www.youtube.com/embed/${params[params.length - 1]}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                );
            },
            'youtube.com': (path) => {
                let p = parseUrlParams(path);
                if (!p.v) return ``;
                return (
                    `<iframe width="560" height="315" src="https://www.youtube.com/embed/${p.v}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                );
            },
            'facebook.com': (url) => {
                return (
                    `<iframe src="https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&width=500&show_text=false&appId=526970354336335&height=280" width="500" height="280" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media" allowFullScreen="true"></iframe>`
                )
            },
            'tvzvezda.ru': (url) => {
                return (
                    `<iframe src="${url}" width="500" height="315" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media" allowFullScreen="true"></iframe>`
                )
            }
        },
        PREPARE: (path) => {
            // if (path.indexOf('mp4/') + 1 > 0) return `https://video.vm.ru${path.replace('https://files.vm.ru', '')}`;
            return path;
        },
    },

};


export const MENU_RUSSIAN_FOR_SK =   [
    {
        'title': 'Рабочий процесс',
        'path': '/',
        'component': 'dashboard_index',
        'icon': 'dashboard',

    },

    {
        'title': 'Статьи',
        'path': '/documents/:type',
        'component': 'default_document',
        'subroutes': [
            {
                'path': '/documents/:type/:id',
                'component': 'add_documents',
            },
            {
                'path': '/documents/:type/:id/preview',
                'component': 'preview',
            },
            {
                'path': '/documents/:type/create',
                'component': 'add_documents',
            },
            {
                'path': '/documents/episode/:id/chat',
                'component': 'episode_chat',
            },
            {
                'path': '/archive',
                'component': 'archive',
            },
        ],
        'icon': 'container',
        'submenu': [
            {
                'title': 'Русский язык',
                'path': '/documents/articles?cat=ru',
                'icon': 'database',
            },
            {
                'title': 'Культура',
                'path': '/documents/articles?cat=culture',
                'icon': 'database',
            },
            {
                'title': 'История',
                'path': '/documents/articles?cat=history',
                'icon': 'database',
            },
            {
                'title': 'Туризм',
                'path': '/documents/articles?cat=tourism',
                'icon': 'database',
            },
            {
                'title': 'Образ жизни',
                'path': '/documents/articles?cat=lifestyle',
                'icon': 'database',
            },
            {
                'title': 'Образование',
                'path': '/documents/articles?cat=education',
                'icon': 'database',
            },
            {
                'title': 'Кухня',
                'path': '/documents/articles?cat=hitchen',
                'icon': 'database',
            },
            {
                'title': 'Учебный курс',
                'path': '/documents/articles?cat=teach',
                'icon': 'database',
            },
        ]
    },

    {
        "title": "Тесты",
        'icon': 'container',
        'submenu': [
            {
                'title': 'Тест на знание русского',
                'path': '/documents/tests',
                'icon': 'file-text',
            }
        ]
    },

    {
        "title": "Видео",
        'icon': 'container',
        'path': '/documents/articles?cat=video',
    },




    {
        'title': 'Каталоги',
        'path': '/documents/:type',
        'component': 'default_document',
        'subroutes': [
            {
                'path': '/documents/:type/:id',
                'component': 'add_documents',
            },
            {
                'path': '/documents/:type/:id/preview',
                'component': 'preview',
            },
            {
                'path': '/documents/:type/create',
                'component': 'add_documents',
            },
            {
                'path': '/documents/episode/:id/chat',
                'component': 'episode_chat',
            },
            {
                'path': '/archive',
                'component': 'archive',
            },
        ],
        'icon': 'container',
        'submenu': [
            {
                'title': 'Фильмы',
                'path': '/documents/films',
                'icon': 'video-camera',
            },
            {
                'title': 'Музыка',
                'path': '/documents/music',
                'icon': 'database',
            },
            {
                'title': 'Книги',
                'path': '/documents/books',
                'icon': 'book',
            },
            {
                'title': 'Performing Arts',
                'path': '/documents/performing_arts',
                'icon': 'customer-service',
            },
            {
                'title': 'Театры',
                'path': '/documents/pa_theater',
                'icon': 'database',
            },
            {
                'title': 'Копирайты',
                'path': '/documents/copyright',
                'icon': 'database',
            },
            {
                "title": "Спектакли онлайн",
                'icon': 'container',
                'path': '/documents/articles?cat=perf',
            },
        ]
    },

    {
        'title': 'Страницы',
        'path': '/documents/page',
        'subroutes': [
            {
                'path': '/documents/:type/:id',
                'component': 'add_documents',
            },
            {
                'path': '/documents/:type/:id/preview',
                'component': 'preview',
            },
            {
                'path': '/documents/:type/create',
                'component': 'add_documents',
            },
            {
                'path': '/documents/episode/:id/chat',
                'component': 'episode_chat',
            },
            {
                'path': '/archive',
                'component': 'archive',
            },
        ],
        'icon': 'container',
        'submenu': [
            {
                'title': 'Описание проекта',
                'path': '/documents/pages?v=1',
                'icon': 'database',
            },
            {
                'title': 'Полезные ссылки',
                'path': '/documents/pages?v=2',
                'icon': 'database',
            },
            {
                'title': 'О команде',
                'path': '/documents/pages?v=3',
                'icon': 'database',
            },
            {
                'title': 'Контакты',
                'path': '/documents/pages?v=4',
                'icon': 'database',
            },
            {
                'title': 'Правила использования',
                'path': '/documents/pages?v=5',
                'icon': 'database',
            },
            {
                'title': 'Политика конфиденциальности',
                'path': '/documents/pages?v=6',
                'icon': 'database',
            }
        ]
    },

    {
        "title": "Справочники",
        "icon": "database",
        "submenu": [
            {
                "title": "Языки",
                "path": "/documents/languages",
                "icon": "global",
            },
            {
                'title': "Категории",
                "path": "/documents/category",
                "icon": "file-text"
            },
            {
                'title': "Теги",
                "path": "/documents/tags",
                "icon": "file-text"
            },
            {
                'title': "Темы",
                "path": "/documents/trends",
                "icon": "file-text"
            },
            {
                'title': "Авторы",
                "path": "/documents/authors",
                "icon": "user"
            },
        ]
    },

    {
        title: "Инструменты",
        icon: "code",
        'submenu': [
            {
                title: "Коллажи",
                path: "/collage_maker",
                icon: "picture",
                component: 'CollageMaker',
            },
            {
                'title': 'Редиректы',
                'path': '/documents/redirects',
                'icon': 'experiment',
            },
            {
                title: 'Фото-архив',
                path: '/mediagallery',
                icon: 'picture',
                component: 'media_gallery',
            },
            {
                title: 'Конвертер',
                path: '/converter',
                icon: 'video-camera',
                component: 'ConverterIndex',
            },
            {
                title: 'Логи писем',
                path: '/service-mail/logs',
                icon: 'file-text',
                component: 'ServiceMailLogs',
            },
        ]
    },
    {
        'title': 'Пуши',
        'path': '/push',
        'icon': 'notification',
        'component': 'push',
    },
    {
        'title': 'Баннеры',
        'path': '/documents/banner',
        'icon': 'database',
    },
    {
        'title': 'Виджеты',
        'path': '/widgets',
        'icon': 'appstore',
        'component': 'widget',
        'submenu': [
            {
                'title': 'Все',
                'path': '/widgets',
                'icon': 'appstore',
                'component': 'widget',
            },
            {
                'title': 'Главная',
                'path': '/widgets/type/main',
                'icon': 'appstore',
            },
            {
                'title': 'Изучение русского',
                'path': '/widgets/type/learn_russia',
                'icon': 'appstore',
            },
            {
                'title': 'Русский язык',
                'path': '/widgets/type/russian_language',
                'icon': 'appstore',
            },
            {
                'title': 'Русский контент',
                'path': '/widgets/type/russian_content',
                'icon': 'appstore',
            },
            {
                'title': 'Полезная информация',
                'path': '/widgets/type/useful_info',
                'icon': 'appstore',
            },
            {
                'title': 'Меню',
                'path': '/widgets/type/menu',
                'icon': 'appstore',
            },
            {
                'title': 'Performing Arts',
                'path': '/widgets/type/performing_arts',
                'icon': 'appstore',
            },
            // {
            //     'title': 'WTYPE_HELP_INFORMATION',
            //     'path': '/widgets/type/help_information',
            //     'icon': 'appstore',
            // },
        ],
        'subroutes': [
            {
                'path': '/widgets/:id',
                'component': 'widget_edit',
            },
            {
                'path': '/widgets/type/:type',
                'component': 'widget',
            },

        ]
    },
    {
        'title': 'Страницы',
        'path': '/documents/page',
        'icon': 'file-text',
    },
    {
        'title': 'Комментарии',
        'path': '/comments',
        'icon': 'message',
        'component': 'QAComments',
    },
    {
        'title': 'Пользователи',
        'path': '/users',
        'icon': 'user',
        'subroutes': [
            {
                'path': '/users/:id',
                'component': 'users_edit',
            },
            {
                'path': '/users/groups/add',
                'component': 'add_group',
            },
            {
                'path': '/users/groups/:id',
                'component': 'add_group',
            }
        ],
        'submenu': [
            {
                'title': 'Пользователи',
                'path': '/users',
                'icon': 'user',
                'component': 'users_index',
            },
            {
                'title': 'Группы',
                'icon': 'idcard',
                'path': '/users/groups',
                'component': 'groups_index',
            },
            {
                'title': 'Права',
                'icon': 'idcard',
                'path': '/users/permissions',
                'component': 'permission_index',
            }
        ]
    },
    {
        'title': 'Отчеты',
        'icon': 'database',
        'submenu': [
            {
                'title': 'Минцифры',
                'path': '/reports/digital',
                'icon': 'database',
                'component': 'ReportDigital',
            },
            {
                'title': 'Регистрации',
                'path': '/reports/registrations',
                'icon': 'team',
                'component': 'RegistrationsReport',
            },
            {
                'title': 'Instagram/Facebook',
                'path': '/reports/meta-sources',
                'icon': 'link',
                'component': 'MetaSourcesReport',
            },
        ]
    }
];

const mediaPrefixMap = {
    "image": "images",
    "cover": "images",
    "video": "videos"
}

export const GetMediaPrefix = (mediaType) => {
    return mediaPrefixMap[mediaType.toLowerCase()] || mediaType.toLowerCase();
}

export const GetMediaPath = (media, size='original') => {
    if (!media || !media.files) return null;
    let mediaSize = media.files[size] ? media.files[size] : media.files["original"];
    let prefix = GetMediaPrefix(media.type);
    if (media.is_rbth_media) {
        return `${RBTHCdnMedia}/${prefix}/${mediaSize.path}`;
    } else {
        return `${GWCdnMedia}/${prefix}/${mediaSize.path}`;
    }
}

export const FixMediaPath = (path, size='original') => {
    let prefix = GetMediaPrefix('image');
    return `${RBTHCdnMedia}/${prefix}/${path}`;
    // if (!media || !media.files) return null;
    // let mediaSize = media.files[size] ? media.files[size] : media.files["original"];

    // if (media.is_rbth_media) {
    //     return `${RBTHCdnMedia}/${prefix}/${mediaSize.path}`;
    // } else {
    //     return `${GWCdnMedia}/${prefix}/${mediaSize.path}`;
    // }
}


export const getCurrentLanguages = () => {
    let lang = store.get(LanguageStorageKey) || "";
    if (!lang) {
        if (window.user && window.user.languages && window.user.languages.length > 0) {
            lang = window.user.languages[0];
        } else {
            lang = window.AL_LIST.Languages[0]['id'];
        }
    }
    return lang;
}

const previewIdSlug = (item) => `${item.publicId}-${item.slug}`;

// Paths match backend GetLink / prepareLink and frontend routes.go.
const previewPathByType = {
    Page: (item) => `/${item.slug}`,
    Category: (item) => `/${item.slug}`,
    Categories: (item) => `/${item.slug}`,
    Useful_categories: (item) => `/${item.slug}`,
    Country: (item) => `/country/${item.slug}`,
    Units: (item) => `/units/${previewIdSlug(item)}`,
    Courses: (item) => `/courses/${previewIdSlug(item)}`,
    Lessons: (item) => `/lessons/${previewIdSlug(item)}`,
    News: (item) => `/news/${previewIdSlug(item)}`,
    Meaning: (item) => `/opinion/${previewIdSlug(item)}`,
    Episode: (item) => `/video/${previewIdSlug(item)}`,
    Episodes: (item) => `/episodes/${previewIdSlug(item)}`,
    Serials: (item) => `/serials/${previewIdSlug(item)}`,
    Arteldoc: (item) => `/arteldoc/${previewIdSlug(item)}`,
    Films: (item) => `/films/${previewIdSlug(item)}`,
    Trend: (item) => `/trends/${previewIdSlug(item)}`,
    Trends: (item) => `/trends/${previewIdSlug(item)}`,
    Tag: (item) => `/tags/${previewIdSlug(item)}`,
    Tags: (item) => `/tags/${previewIdSlug(item)}`,
    Gallery: (item) => `/photogallery/${previewIdSlug(item)}`,
    Author: (item) => `/author/${previewIdSlug(item)}`,
    Authors: (item) => `/author/${previewIdSlug(item)}`,
    Quiz: (item) => `/quiz/${previewIdSlug(item)}`,
    Book: (item) => `/catalog/books/${previewIdSlug(item)}`,
    Film: (item) => `/catalog/films/${previewIdSlug(item)}`,
    Performing_Arts: (item) => `/catalog/performing-arts/${previewIdSlug(item)}`,
    Performing_arts: (item) => `/catalog/performing-arts/${previewIdSlug(item)}`,
    Music: (item) => `/catalog/music/${previewIdSlug(item)}`,
    Music_authors: (item) => `/catalog/music/composers/${previewIdSlug(item)}`,
    Music_author: (item) => `/catalog/music/composers/${previewIdSlug(item)}`,
    Person: (item) => `/catalog/films/person/${previewIdSlug(item)}`,
    Pa_theater: (item) => `/catalog/performing-arts/theater/${previewIdSlug(item)}`,
    Copyright: (item) => `/catalog/performing-arts/copyright/${previewIdSlug(item)}`,
    Genre: (item) => `/catalog/genres/${previewIdSlug(item)}`,
    Music_genre: (item) => `/catalog/music/genres/${previewIdSlug(item)}`,
};

export const GeneratePreviewUrl = (item) => {
    const currentLanguage = getCurrentLanguages();
    const lng = window.AL_LIST && window.AL_LIST.Languages ? window.AL_LIST.Languages.filter(i => i.id === currentLanguage).map(i => {
        return i.redirectTo
    }) : ['www.gw2ru.com'];

    const path = previewPathByType[item.type] ? previewPathByType[item.type](item) : '';
    if (path) {
        return `https://${lng[0]}${path}`;
    }

    const params = ['https:/', lng[0]];
    if (item.category && item.category.slug) {
        params.push(item.category.slug);
    }
    params.push(previewIdSlug(item));
    return params.join('/');
}

export const GeneratePreviewNewsletter = (item) => {
    const currentLanguage = getCurrentLanguages();
    const lng = window.AL_LIST && window.AL_LIST.Languages ? window.AL_LIST.Languages.filter(i => i.id === currentLanguage).map(i => {
        return i.redirectTo
    }) : ['www.gw2ru.com'];

    if (window.location.hostname.indexOf('localhost') + 1 > 0) {
        return `http://localhost:14002/api/newsletter/${item.id}`;
    }

    const params = ['https:/', lng[0]];
    params.push('api/newsletter');
    params.push(item.id)
    return params.join('/');
}

export const GenerateIframeUrl = (item) => {
    const currentLanguage = getCurrentLanguages();
    const lng = window.AL_LIST && window.AL_LIST.Languages ? window.AL_LIST.Languages.filter(i => i.id === currentLanguage).map(i => {
        return i.redirectTo
    }) : ['www.gw2ru.com'];

    return window.location.hostname.indexOf('localhost') + 1 > 0 ? `http://localhost:14002/preview/${item.id}` : `https://${lng[0]}/preview/${item.id}`
}


export default gateway;
